import {Association} from './association.model';

export class CategoryAssociationModel {
  id: number;
  is_active: boolean;
  name: string;
  description: string;
  assocs: Association[];
}
